<template>
  <div class="wx-open-btn-wrap">
    <slot name="default"></slot>
    <wx-open-launch-app
      class="launch-btn"
      ref="btn"
      appid="wx9b913299215a38f2"
      :extinfo="schema"
      :path="schema"
      v-show="showLunchBtn"
    >
      <script type="text/wxtag-template">
        <style>
          .btn{ width:100%;
                height:100%;
                border: 0;
                outline: none;
                opacity:0;
                z-index:99;
                position:absolute;
                top:0;
                left:0;
                -webkit-tap-highlight-color:transparent !important
                }</style>
        <button class="btn"></button>
      </script>
    </wx-open-launch-app>
  </div>
</template>

<script>
import { webviewInfo, log } from '@ali/amap-lib';
import Monitor from '@ali/act-monitor';
import Vue from 'vue';

Vue.config.ignoredElements = [
  'wx-open-launch-app'
];

export default {
  name: 'wxLunchBtn',
  props: {
    schema: {
      type: String,
    }
  },
  data() {
    return {
      isInWeixin: webviewInfo.isInWeixin(),
      // sdk 加载完毕
      isTagReady: false,
    };
  },
  methods: {
    tagError(event) {
      console.log('tagError', event);
      this.isTagReady = false;
    }
  },
  computed: {
    showLunchBtn() {
      console.log({
        isTagReady: this.isTagReady,
        isInWeixin: this.isInWeixin,
        schema: this.schema,
      });

      return this.isInWeixin
        && this.isTagReady
        && this.schema;
    }
  },
  beforeCreate() {
  },
  beforeDestroy() {
    document.removeEventListener('WeixinOpenTagsError', this.tagError);
  },
  async mounted() {
    document.addEventListener('WeixinOpenTagsError', this.tagError);

    const { btn } = this.$refs;
    if (btn) {
      btn.addEventListener('launch', () => {
        console.log('launch');
        log.log('opentagsuc');
      });

      btn.addEventListener('error', (res) => {
        log.log('opentagerror');
        console.log('wx open tag error=', res.detail);
        Monitor.log({ msg: '唤端失败', detail: res.detail });
        this.$emit('error');
      });

      btn.addEventListener('click', (res) => {
        log.log('opentag');
        console.log('wxbtnclick');
        res.stopPropagation();
        this.$emit('wxClick'); // 按钮点击
      });

      btn.addEventListener('ready', (event) => {
        console.error('btn.ready:', event);
        this.isTagReady = true;
      });
    }
  }
};
</script>

<style lang="scss">
.wx-open-btn-wrap {
  position: relative;
  .launch-btn {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}
</style>
